<template>
    <div class="schedule" :ref="status">
        <div class="scheduled" v-if="status == 'scheduled'">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 277.92 225.3" style="enable-background:new 0 0 277.92 225.3;" xml:space="preserve">
                <g>
                    <path
                    :style="defineStroke"
                    class="st0" d="M94.01,172.16c-1.89,0.13-3.79,0.19-5.71,0.19c-45.93,0-83.16-37.23-83.16-83.16S42.37,6.03,88.3,6.03
                        s83.16,37.23,83.16,83.16c0,28.25-14.08,53.21-35.61,68.24"/>
                    <path :style="defineStroke" class="st1" d="M95.2,156.29c-2.27,0.23-4.57,0.35-6.9,0.35c-37.25,0-67.45-30.2-67.45-67.45s30.2-67.45,67.45-67.45
                        s67.45,30.2,67.45,67.45c0,23.92-12.45,44.93-31.23,56.91"/>
                    <polyline :style="defineFill" class="st2" points="88.3,52.01 88.3,89.19 123.23,124.11 	"/>
                    <polyline :style="defineStroke" class="st0" points="124.98,13.98 269.3,13.98 269.3,40.74 155.76,40.74 	"/>
                    <polyline :style="defineStroke" class="st0" points="188.55,167.49 269.3,167.49 269.3,40.74 	"/>
                    <rect :style="defineStroke" x="218.46" y="66.44" class="st1" width="28.96" height="28.96"/>
                    <polyline :style="defineStroke" class="st1" points="218.46,123.69 218.46,113.36 247.42,113.36 247.42,142.32 218.46,142.32 218.46,137.08 	"/>
                    <rect :style="defineStroke" x="172.63" y="66.44" class="st1" width="28.96" height="28.96"/>
                </g>
                <g>
                    <polygon :style="defineStroke" class="st0" points="138.7,216.84 86.83,164.97 115.12,136.69 138.7,160.27 196.87,102.1 225.16,130.39 	"/>
                </g>
            </svg>          
        </div>        
        <div class="default" v-else>
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 270.46 178.09" style="enable-background:new 0 0 270.46 178.09;" xml:space="preserve">
                <circle :style="defineStroke" class="st0" cx="89.99" cy="89.41" r="83.16"/>
                <circle :style="defineStroke" class="st1" cx="89.99" cy="89.41" r="67.45"/>
                <polyline :style="defineFill" class="st2" points="89.99,52.23 89.99,89.41 124.92,124.34 "/>
                <polyline :style="defineStroke" class="st0" points="125.53,14.21 258.99,14.21 258.99,40.96 156.1,40.96 "/>
                <polyline :style="defineStroke" class="st0" points="118.54,167.71 258.99,167.71 258.99,40.96 "/>
                <rect :style="defineStroke" x="208.15" y="66.67" class="st1" width="28.96" height="28.96"/>
                <rect :style="defineStroke" x="208.15" y="113.58" class="st1" width="28.96" height="28.96"/>
                <polyline :style="defineStroke" class="st1" points="170.01,66.67 191.28,66.67 191.28,95.63 171.29,95.63 "/>
                <polyline :style="defineStroke" class="st1" points="169.59,113.58 191.28,113.58 191.28,142.54 155.86,142.54 "/>
            </svg>            
        </div>
    </div>
</template>

<script>
export default {
    data:() => ({colors: ''}),
    props:{
        status: {
            require: false,
            type: String
        }
    },
    created(){
        // console.log("STATUS ------------: ", this.status)
        this.colors = JSON.parse(localStorage.getItem('colors'))
    },
    computed:{
        defineStroke(){
            if(this.status == 'schedule-block' || this.status == 'schedule-finished' || this.status == 'schedule-sucess' || this.status == 'finished') return {'stroke': '#bfbfbf'}
            if(this.status == 'schedule-dash-open' || this.status == 'scheduled-expired' || this.status == 'scheduled'|| this.status == 'dash-open') return {'stroke': this.colors.secondary}
            if(this.status == 'started-game') return {'stroke': '#fff'}
        },
        defineFill(){
            if(this.status == 'schedule-block' || this.status == 'schedule-finished' || this.status == 'schedule-sucess' || this.status == 'finished') return {
               'fill':'none','stroke':'#bfbfbf','stroke-width':10,'stroke-miterlimit':10
            }
            if(this.status == 'schedule-dash-open' || this.status == 'scheduled-expired' || this.status == 'scheduled'|| this.status == 'dash-open') return {
                'fill':'none','stroke':this.colors.secondary,'stroke-width':10,'stroke-miterlimit':10
            }
            if(this.status == 'started-game') return {
                'fill':'none','stroke':'#fff','stroke-width':10,'stroke-miterlimit':10
            }
        }
    }
}
</script>

<style lang="scss" scoped>
	// .st0{fill:none;stroke:#6D45B2;stroke-width:7;stroke-miterlimit:10;}
	// .st1{fill:none;stroke:#6D45B2;stroke-width:6;stroke-miterlimit:10;}
	// .st2{fill:none;stroke:#6D45B2;stroke-width:10;stroke-miterlimit:10;}
</style>